import {createAsyncThunk} from "@reduxjs/toolkit";
import instance from "@/config/axios";

export const forgotPassword = createAsyncThunk('password/forgotPassword',
  async (email: string) => {
    const url = 'v1/auth/forgot-password'
    await instance.post(url, { email })
  })

export const resetPassword = createAsyncThunk('password/resetPassword',
  async ({ password, token }: { password: string, token: string }) => {
    const url = 'v1/auth/reset-password'
    await instance.post(url, { new_password: password }, { headers: { Authorization: `Bearer ${token}` } })
  })
